import type { ReactNode } from 'react';
import styles from './MenuCount.module.css';

interface MenuCountProps {
  readonly count: number | undefined;
  /** What the number means, read aloud: "2 invitations not accepted yet". */
  readonly label: string;
}

/** FRAME-SPEC §2: a small red chip only where it is a to-do. Nothing at all when there is nothing to do. */
export function MenuCount({ count, label }: MenuCountProps): ReactNode {
  if (count === undefined || count <= 0) return null;
  return (
    <>
      <span className={styles.count} aria-hidden>
        {count > 99 ? '99+' : count}
      </span>
      <span className="sr-only">{label}</span>
    </>
  );
}
